<template>
  <b-form @submit.stop="$emit('submit-recipe', recipe)">
    <b-form-group
      class="px-0"
      id="input-group-1"
      label-for="beschrijvingArea"
      description="Deel je recepten en boodschappenlijst met een huisgenoot!"
    >
      <b-row v-if="editable" class="border-0">
        <!-- mobile variant -->
        <b-col cols="auto" class="ml-auto d-block d-xl-none py-2">
          <b-button
            :variant="editable ? 'secondary' : 'primary'"
            title="Receptgegevens aanpassen"
            :pressed="false"
            @click="$emit('show-description-modal')"
          >
            <b-icon
              :icon="editable ? 'pencil-fill' : 'pencil'"
              :variant="editable ? 'dark' : 'default'"
            />
          </b-button>
        </b-col>
      </b-row>

      <!-- Edit-modus: bewerk de ruwe markdown in een textarea -->
      <template v-if="editable">
        <b-row>
          <b-col class="d-block d-xl-none">
            <b-form-textarea
              class="bg-light rounded-0"
              id="beschrijvingArea"
              v-model="description"
              style="font-size:24px"
              rows="3"
              max-rows="100"
              @change="updateDescription"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-none d-xl-block mt-4 mb-4">
            <b-form-textarea
              class="bg-light"
              id="beschrijvingArea"
              v-model="description"
              @change="updateDescription"
              size="lg"
              rows="3"
              max-rows="15"
            />
          </b-col>
        </b-row>
      </template>

      <!-- Lees-modus: gerenderde markdown -->
      <template v-else>
        <b-row>
          <b-col class="d-block d-xl-none">
            <div
              v-if="renderedDescription"
              class="recipe-description-rendered bg-light rounded-0 p-3"
              style="font-size:20px"
              v-html="renderedDescription"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-none d-xl-block mt-4 mb-4">
            <div
              v-if="renderedDescription"
              class="recipe-description-rendered bg-light p-3"
              v-html="renderedDescription"
            />
          </b-col>
        </b-row>
      </template>
    </b-form-group>
  </b-form>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ breaks: true, gfm: true });

export default {
  name: 'RecipeDescription',
  props: {
    recipe: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      description: this.recipe.beschrijving || ''
    };
  },
  computed: {
    renderedDescription() {
      if (!this.description) return '';
      return DOMPurify.sanitize(marked.parse(this.description));
    }
  },
  watch: {
    'recipe.beschrijving'(newVal) {
      this.description = newVal || '';
    }
  },
  methods: {
    updateDescription() {
      if (this.editable) {
        const updatedRecipe = { ...this.recipe, beschrijving: this.description };
        this.$emit('update-recipe', updatedRecipe);
      }
    }
  }
};
</script>

<style scoped>
.recipe-description-rendered {
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.5;
}

.recipe-description-rendered >>> h1,
.recipe-description-rendered >>> h2,
.recipe-description-rendered >>> h3,
.recipe-description-rendered >>> h4 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.recipe-description-rendered >>> p {
  margin-bottom: 0.75rem;
}

.recipe-description-rendered >>> ul,
.recipe-description-rendered >>> ol {
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
}

.recipe-description-rendered >>> li {
  margin-bottom: 0.25rem;
}

.recipe-description-rendered >>> code {
  background-color: rgba(0, 0, 0, 0.06);
  padding: 0.1em 0.3em;
  border-radius: 0.2em;
}

.recipe-description-rendered >>> blockquote {
  border-left: 3px solid #ced4da;
  padding-left: 0.75rem;
  color: #6c757d;
  margin: 0.5rem 0;
}

.recipe-description-rendered >>> a {
  color: #0d6efd;
}

.recipe-description-rendered >>> :first-child {
  margin-top: 0;
}

.recipe-description-rendered >>> :last-child {
  margin-bottom: 0;
}
</style>
